<template lang="html">
    <div>
        <div class="container container-medium pb-4">
            <Heading :title="$t('order_title') + (type == 'vignette' ? 'ERV' : 'PJ') + id" :routeName="'my-orders'" :heading-class="'heading-medium'"></Heading>
            <div class="alert alert-danger text-center mt-5" v-if="order == null && !loading">
                {{ $t('no_order') }}
            </div>

            <template v-if="order && !loading">
                <div class="order mt-3">
                    <span class="ancillary">{{$t('date')}}:</span> {{order.date}}<br/>
                    <span class="ancillary">{{$t('product_status')}}:</span> {{order.status.name}}<br/>
                    <template v-if="order.payment_type">
                        <span class="ancillary">{{$t('product_payment_method')}}:</span> {{order.payment_type.descriere}}<br/>
                    </template>
                    <span class="ancillary">{{$t('product_bill_data')}}:</span> {{order.orderAddress}}, {{order.orderCity}}, {{order.orderCountry}}<br/>
                    <span class="ancillary">{{$t('total')}}:</span> <b>{{parseFloat(order.orderTotalLei + order.orderTotalLeiSMS).toFixed(2)}} {{ $tc('currency', parseFloat(order.orderTotalLei + order.orderTotalLeiSMS)) }}</b>
                </div>
                
                <div class="row justify-content-center">
                    <div class="col-auto">
                        <template v-if="order.orderInvoice.length">
                            <div class="bill-btns">
                                <button v-if="type == 'vignette'" @click.prevent="openUrl(erv_invoice_url + order.orderToken)" href="#" class="main-btn mt-3" target="_blank">{{ $t('download_bill') }}</button>
                                <button v-if="type == 'toll'" @click.prevent="openUrl(toll_invoice_url + order.orderToken)" href="#" class="main-btn mt-3" target="_blank">{{ $t('download_bill') }}</button>
                            </div>
                        </template>
                    </div>
                    <div class="col-auto">
                        <template v-if="order.orderInvoiceSMS != '' && order.orderInvoiceSMS != null">
                            <div class="bill-btns">
                                <button v-if="type == 'vignette'" @click.prevent="openUrl(erv_invoice_sms_url + order.orderToken)" href="#" class="main-btn mt-3" target="_blank">{{ $t('download_bill_sms') }}</button>
                                <button v-if="type == 'toll'" @click.prevent="openUrl(toll_invoice_sms_url + order.orderToken)" href="#" class="main-btn mt-3" target="_blank">{{ $t('download_bill_sms') }}</button>
                            </div>
                        </template>
                    </div>
                    <div class="col-auto">
                        <template v-if="order.hasClientCopy">
                            <div class="bill-btns">
                                <button v-if="type == 'vignette'" @click.prevent="openUrl(erv_client_copy_url + order.orderToken)" href="#" class="main-btn mt-3" target="_blank">{{ $t('download_client_copy') }}</button>
                                <button v-if="type == 'toll'" @click.prevent="openUrl(toll_client_copy_url + order.orderToken)" href="#" class="main-btn mt-3" target="_blank">{{ $t('download_client_copy') }}</button>
                            </div>
                        </template>
                    </div>
                </div>


                <div class="product mt-3" v-for="product in order.products" v-if="product.oProdStatus == 0">
                    <b>{{product.oProdProductName}}</b><br/>
                    <span class="ancillary" v-html="product.category.desc"></span>
                    <div class="row mt-2 mb-2">
                        <div class="col-6">
                            <b>{{product.oProdVehicleNo}}</b>
                        </div>
                        <div class="col-6 text-right text-truncate">
                            {{product.oProdChasisNo}}
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-6">
                            <span v-if="type == 'vignette'">1 {{$tc('vignetteWord', 0)}}</span>
                            <span v-if="type == 'toll'">{{product.oProdPeriodName}}</span>
                        </div>
                        <div class="col-6">
                            <div class="text-right">
                                <b>{{parseFloat(product.oProdPrice).toFixed(2)}} {{ $tc('currency', product.oProdPrice) }}</b>
                            </div>
                        </div>
                    </div>

                    <template v-if="type == 'vignette'">
                        <span class="d-block mt-2"><span class="ancillary">{{$t('product_valability')}}:</span> {{product.oProdPeriodName}}</span>
                        <template v-if="product.date_start_availability">{{product.date_start_availability}}<br/></template>
                        <template v-if="product.date_stop_availability">{{product.date_stop_availability}}<br/></template>
                    </template>
                    <template v-if="type == 'toll'">
                        <span class="d-block mt-2"><span class="ancillary">{{$t('product_valability')}}:</span> 1 an</span>
                    </template>

                    <template v-if="type == 'vignette'">
                        <span class="ancillary d-block mt-2">{{$t('vignette_series')}}:</span>
                        {{product.oProdVignetteSerie ? product.oProdVignetteSerie : 'n/a'}}
                    </template>
                    <template v-if="type == 'toll'">
                        <span class="ancillary d-block mt-2">{{$t('toll_series')}}:</span>
                        {{product.oProdPeajSerie ? product.oProdPeajSerie : 'n/a'}}
                    </template>
                    
                    <div class="mt-2">
                        <span class="ancillary d-block" v-if="product.oProdSMSConfirmation"><span class="far fa-envelope"></span>
                            {{ $tc('sms_notification_confirmation', Math.ceil(product.oProdSMSConfirmation), { 'price': getSmsSettingMessage(product.oProdSMSConfirmation) }) }}</span>
                        <span class="ancillary d-block" v-if="product.oProdSMSExpiry"><span class="far fa-envelope"></span> {{
                            $tc('sms_notification_expiry', Math.ceil(product.oProdSMSExpiry), { 'price': getSmsSettingMessage(product.oProdSMSExpiry) })
                        }}</span>
                        <span class="ancillary d-block" v-if="product.oProdCnairNotify"><span class="far fa-envelope"></span> {{
                            $t('cnair_notification_expiry')
                        }}</span>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>

import Heading from './../snippets/Heading.vue'
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
    name: 'Order',
    components: {
        Heading
    },
    data: function() {
        return {
            loading: true,
            erv_invoice_url: process.env.VUE_APP_ERV_INVOICE_URL,
            erv_client_copy_url: process.env.VUE_APP_ERV_CLIENT_COPY_URL,
            erv_invoice_sms_url: process.env.VUE_APP_ERV_INVOICE_SMS_URL,
            toll_invoice_sms_url: process.env.VUE_APP_PEAJ_INVOICE_SMS_URL,
            toll_invoice_url: process.env.VUE_APP_PEAJ_INVOICE_URL,
            toll_client_copy_url: process.env.VUE_APP_PEAJ_CLIENT_COPY_URL
        }
    },
    computed: {
        ...mapState('orders', [
            'order'
        ]),

        ...mapGetters({
            getSmsSetting: 'settings/getSmsSetting',
            getSmsSettingMessage: 'settings/getSmsSettingMessage'
        })
    },
    props: [
        'id',
        'type'
    ],
    async mounted() {
        await this.getOrder({id: this.id, type: this.type});
        this.loading = false;
    },
    methods: {
        ...mapActions('orders', [
            'getOrder'
        ])
    }
}
</script>

<style lang="scss" scoped>

$lightgrey: lightgrey;
$green: #59af54;
$light-grey: #D6D6D6;

.order {
    border: 1px solid #F1F1F1;
    padding: 10px;
    border-radius: 5px;
}

.product {
    border: 1px solid #F1F1F1;
    padding: 10px;
    border-radius: 5px;
}

.btn-invoice {
    border: 1px solid #54AD32;
    display: block;
    color: #54AD32;
    padding: 10px;
    text-decoration: none;
    text-align: center;
    border-radius: 5px;
}

.bill-btns {
    margin: 0 auto;
    max-width: 400px;
}

</style>
